import { Dimensions, useWindowDimensions } from 'react-native'
import _ from 'lodash'
import { getViewportLayout, viewportBreakpoints } from 'utils/viewport'

const deviceSizes  = {
	xs: 0,
	sm: viewportBreakpoints.sm,
	md: viewportBreakpoints.md,
	lg: viewportBreakpoints.lg,
	//xl: 1200
}

export const useViewportLayout = () => {
	return getViewportLayout( useWindowDimensions() );
}

export const useShowHamburger = () => {
	return useViewportLayout().isSmallDevice;
}

export const useIsSmallDevice = () => {
	return useViewportLayout().isSmallDevice;
}

export const deviceSize = {
	size: () => {
		return getViewportLayout( Dimensions.get( 'window' ) ).size;
	},
	
	parse: ( obj, size = deviceSize.size() ) => {
		
		if ( obj[ size ] ) {
			return obj[ size ];
		}
		
		// Get the next size in the list?
		const nextSize = _.findKey( deviceSizes, ( value, key ) => {
			return value > deviceSizes[ size ];
		})
		
		return _.last( Object.values( obj ) );
	}
}
